<template>
    <div>
        <div class="main-button-bar">
            <el-badge :value="workInfo.step1" :max="9999" class="gmap-button">
                <el-button type="success" plain size="small" @click="step1">STEP1.导入地图数据</el-button>
            </el-badge>
            
            <!-- <el-badge :value="workInfo.step2" :max="9999" class="gmap-button">
                <el-button type="primary" plain size="small" @click="step2">STEP2.导入邮箱数据</el-button>
            </el-badge> -->

            <!-- <el-button type="primary" plain size="small" @click="step2">STEP2.匹配邮箱数据</el-button> -->
            
            <el-button class="gmap-button" type="danger" plain size="small" @click="step3">STEP2.数据清洗</el-button>

            <el-badge :value="workInfo.step4" :max="9999" class="gmap-button">
                <el-button type="primary" plain size="small" @click="step4">STEP3.生成公海数据</el-button>
            </el-badge>
            
            <el-button class="gmap-button" type="info" plain size="small" @click="step5">STEP4.设置每月额度</el-button>

            <el-button class="gmap-button" type="info" plain size="small" @click="stepa('N')">设置自动清洗关键词</el-button>
            <el-button class="gmap-button" type="info" plain size="small" @click="stepa('Y')">设置自动选定关键词</el-button>
            <el-button class="gmap-button" type="info" plain size="small" @click="step6">数据总览</el-button>
        </div>

        <el-dialog title="导入地图数据" width="600px" :visible.sync="step1Dialog" @closed="step1Dialog = false" class="step1-dialog">
            <el-form ref="form1"  :rules="rules1" :model="step1Data">
                <el-form-item label="批号" prop="code">
                    <el-input placeholder="请输入批号" v-model="step1Data.code" class="search-item"></el-input>
                </el-form-item>

                <el-form-item label="所属国家" prop="country">
                    <el-cascader
                        v-model="step1Data.country"
                        clearable
                        placeholder="选择国家"
                        class="search-item"
                        :options="$tools.countrys"
                        :props="countryprops2"
                        style="width: 100%"
                    ></el-cascader>
                </el-form-item>
                
                <el-form-item label="导入文件" required="true">
                    <el-upload ref="upload1" action="/api/file/upload/temp" :file-list="fileList1" :on-success="uploaded1">
                        <el-button size="small" type="primary">选取文件</el-button>
                        <div slot="tip" class="el-upload__tip">可以导入多个文件，但是只会归属一个国家，导入文件后后台异步执行。</div>
                    </el-upload>
                </el-form-item>
            </el-form>       
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="save1">导入</el-button>
            </div>
        </el-dialog>

        <el-dialog title="导入邮箱数据" width="600px" :visible.sync="step2Dialog" @closed="step2Dialog = false" class="step1-dialog">
            <el-form>
                <el-form-item label="导入文件" required="true">
                    <el-upload ref="upload1" action="/api/file/upload/temp" :file-list="fileList2" :on-success="uploaded2">
                        <el-button size="small" type="primary">选取文件</el-button>
                        <div slot="tip" class="el-upload__tip">可以导入多个文件，导入文件后后台异步执行。</div>
                    </el-upload>
                </el-form-item>
            </el-form>       
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="save2">导入</el-button>
            </div>
        </el-dialog>

        <el-drawer class="step3-dialog" title="数据清洗" :visible.sync="step3Dialog" direction="btt" :size="this.$tools.mainHeight() + 'px'" :destroy-on-close="true">
            <div class="main-button-bar">
                <el-input placeholder="请输入批号" v-model="step3Data.code" class="search-item"></el-input>

                <el-cascader
                        v-model="step3Data.countryArr"
                        clearable
                        collapse-tags
                        :show-all-levels="true"
                        placeholder="所属国家"
                        class="search-item"
                        :options="$tools.countrys"
                        :props="countryprops"
                        :multiple="false"
                ></el-cascader>
                <el-input placeholder="请输入经营类型" v-model="step3Data.type" class="search-item"></el-input>

                <el-select
                    v-model="step3Data.valid"
                    placeholder="是否有效"
                    class="search-item"
                    clearable
                >
                    <el-option v-for="item in Yndata" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <el-button type="primary" @click="pageValid(1)">搜索</el-button>
                <el-button type="warning" @click="validList" v-if="!step3Data.valid">一键选定</el-button>
                <el-button type="danger" @click="unvalidList" v-if="!step3Data.valid">一键清洗</el-button>

                <el-button type="success" @click="autoValid" v-if="!step3Data.valid">自动清洗</el-button>
            </div>
            <el-table
                :data="validData" stripe
                style="width: 100%"
                :height="this.$tools.mainHeight() - 168"
            >
                <el-table-column prop="code" label="批号" width="150" show-overflow-tooltip></el-table-column> 
                <el-table-column prop="country" label="国家" width="100">
                    <template slot-scope="rdata">{{ $tools.countryName(rdata.row.country)}}</template>
                </el-table-column>
                <el-table-column prop="title" label="基本信息" width="400" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="经营类型" width="200" show-overflow-tooltip>
                    <template slot-scope="rdata">
                        <el-button type="text" @click="copyType(rdata.row.type)">{{rdata.row.type}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="map" label="地图" width="60">
                    <template slot-scope="rdata">
                        <el-link class="el-icon-location-information" type="primary" v-if="rdata.row.map != null" circle target="_blank" :href="rdata.row.map"></el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="网址" width="200" show-overflow-tooltip>
                    <template slot-scope="rdata">
                        <el-link type="primary" :href="'http://' + rdata.row.id" target="_blank">{{rdata.row.id}}</el-link>
                    </template>
                </el-table-column>
                
                <el-table-column prop="phone" label="电话" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="mail" label="邮箱" width="500" show-overflow-tooltip>
                    <template slot-scope="rdata">
                        <el-tag class="attr-tag" :key="tag" v-for="tag in formatStrint2Arr(rdata.row.mail)">{{tag}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="adress" label="地址" width="300"></el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="rdata">
                        <el-button type="text" size="small" @click="validOne(rdata.row.id)" v-if="!rdata.row.valid">选定 </el-button>
                        <el-button type="text" size="small" @click="unvalidOne(rdata.row.id)" v-if="!rdata.row.valid">清洗 </el-button>
                        <el-button type="text" size="small" @click="cleanValidOne(rdata.row.id)" v-else>还原</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                layout="total, prev, pager, next"
                :total="step3Data.total"
                :current-page.sync="step3Data.current"
                @current-change="pageValid"
            ></el-pagination>
        </el-drawer>

        <el-drawer class="step4-dialog" title="生成公海数据" :visible.sync="step4Dialog" direction="btt" :size="this.$tools.mainHeight() + 'px'" :destroy-on-close="true">
            <div class="main-button-bar">
                <el-input placeholder="请输入批号" v-model="step4Data.code" class="search-item"></el-input>

                <el-cascader
                        v-model="step4Data.countryArr"
                        clearable
                        collapse-tags
                        :show-all-levels="true"
                        placeholder="所属国家"
                        class="search-item"
                        :options="$tools.countrys"
                        :props="countryprops"
                        :multiple="false"
                ></el-cascader>
                <el-input placeholder="请输入经营类型" v-model="step4Data.type" class="search-item"></el-input>

                <el-button type="primary" @click="pageCreate(1)">搜索</el-button>
                <el-button type="danger" @click="opStep4Dialog2()">一键生成</el-button>
            </div>

            <el-table
                :data="validData" stripe
                style="width: 100%"
                :height="this.$tools.mainHeight() - 168"
            >   
                <el-table-column prop="code" label="批号" width="150" show-overflow-tooltip></el-table-column> 
                <el-table-column prop="country" label="国家" width="100">
                    <template slot-scope="rdata">{{ $tools.countryName(rdata.row.country)}}</template>
                </el-table-column>
                <el-table-column prop="title" label="基本信息" width="400" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="经营类型" width="200" show-overflow-tooltip>
                    <template slot-scope="rdata">
                        <el-button type="text" @click="copyType(rdata.row.type)">{{rdata.row.type}}</el-button>
                    </template>

                </el-table-column>
                <el-table-column prop="map" label="地图" width="60">
                    <template slot-scope="rdata">
                        <el-link class="el-icon-location-information" type="primary" v-if="rdata.row.map != null" circle target="_blank" :href="rdata.row.map"></el-link>
                    </template>
                </el-table-column>
                <el-table-column label="网址" width="200" show-overflow-tooltip>
                    <template slot-scope="rdata">
                        <el-link type="primary" :href="'http://' + rdata.row.id" target="_blank">{{rdata.row.id}}</el-link>
                    </template>
                </el-table-column>
                
                <el-table-column prop="phone" label="电话" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="mail" label="邮箱" width="500" show-overflow-tooltip>
                    <template slot-scope="rdata">
                        <el-tag class="attr-tag" :key="tag" v-for="tag in formatStrint2Arr(rdata.row.mail)">{{tag}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="adress" label="地址" width="300" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="rdata">
                        <el-link type="danger" @click="opStep4Dialog2(rdata.row.id)">生成</el-link>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                layout="total, prev, pager, next"
                :total="step4Data.total"
                :current-page.sync="step4Data.current"
                @current-change="pageCreate"
            ></el-pagination>
        </el-drawer>

        <el-dialog title="生成设置" width="600px" :visible.sync="step4Dialog2" @closed="step4Dialog2 = false">
            <el-form>
                <el-form-item label="归属业务">
                    <sn-user-search-input
                            class="search-item"
                            @change="
                    (a) => {
                        step4Data.toUser = a;
                    }
                    "
                        ></sn-user-search-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="docreate">生成</el-button>
            </div>
        </el-dialog>

        <el-drawer class="step5-dialog" title="设置每月额度" :visible.sync="step5Dialog" direction="btt" :size="this.$tools.mainHeight() + 'px'" :destroy-on-close="true">
            <el-table
                :data="users" stripe
                style="width: 100%"
                :height="this.$tools.mainHeight() - 108"
            >
                <el-table-column prop="name" label="名称" width="200"></el-table-column>
                <el-table-column prop="grade" label="积分" width="100"></el-table-column>
                <el-table-column prop="grade" label="段位" width="100">
                    <template slot-scope="rdata">
                        {{ $tools.levelTag(rdata.row.grade) }}
                    </template>
                </el-table-column>
                <el-table-column prop="maxCustomerNumber" label="最大数量" width="100"></el-table-column>
                <el-table-column prop="useCustomerNumber" label="本月已用" width="100"></el-table-column>
                <el-table-column label="操作" width="100">
                        <template slot-scope="rdata">
                            <el-link type="primary" @click="setMax(rdata.row.id)">设置</el-link>
                        </template>
                </el-table-column>
            </el-table>

            <el-pagination
                layout="total, prev, pager, next"
                :total="step5Data.total"
                :current-page.sync="step5Data.current"
                @current-change="pageUser"
            ></el-pagination>
        </el-drawer>

        <el-dialog title="设置" width="300px" :visible.sync="step5Dialog2" @closed="step5Dialog2 = false">
            <el-form>
                <el-form-item label="数量">
                    <el-input-number v-model="step5Data2.maxCustomerNumber" controls-position="right" :controls=false :min="0"  :precision="0"></el-input-number>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="saveMax">保存</el-button>
            </div>
        </el-dialog>

        <el-drawer class="stepa-dialog" :title="(setType == 'N' ? '清洗' : '选定') + '关键词设置'" :visible.sync="stepaDialog" direction="btt" :size="this.$tools.mainHeight() + 'px'" :destroy-on-close="true">
            <div class="main-button-bar">
                <el-input closable="true" placeholder="请输入关键词" class="search-item" v-model="setName"></el-input>
                <el-button type="primary" @click="addSetData">添加</el-button>
            </div>

            <div class="set-data" :style="'overflow-y: auto;height:' + (this.$tools.mainHeight() - 138) + 'px'">
                <el-tag :type="setType == 'N' ? 'danger' : 'success'" class="set-data-tag" v-for="d in setData" closable="true" @close="delSetData(d.id)">{{ d.id }}</el-tag>
            </div>
        </el-drawer>

        <el-drawer class="step6-dialog" title="数据总览" :visible.sync="step6Dialog" direction="btt" :size="this.$tools.mainHeight() + 'px'" :destroy-on-close="true">
            <div class="main-button-bar">
                <el-input placeholder="请输入批号" v-model="step6Data.code" class="search-item"></el-input>

                <el-cascader
                        v-model="step6Data.countryArr"
                        clearable
                        collapse-tags
                        :show-all-levels="true"
                        placeholder="所属国家"
                        class="search-item"
                        :options="$tools.countrys"
                        :props="countryprops"
                        :multiple="false"
                ></el-cascader>
                <el-input placeholder="请输入经营类型" v-model="step6Data.type" class="search-item"></el-input>

                <el-select
                    v-model="step6Data.hasMail"
                    placeholder="邮箱状态"
                    class="search-item"
                    :clearable="true"
                >
                    <el-option v-for="item in mdata" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>


                <el-select
                    v-model="step6Data.valid"
                    placeholder="清洗状态"
                    class="search-item"
                    :clearable="true"
                >
                    <el-option v-for="item in Yndata" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <el-select
                    v-model="step6Data.added"
                    placeholder="生成状态"
                    class="search-item"
                    :clearable="true"
                >
                    <el-option v-for="item in tdata" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <el-button type="primary" @click="pageAll(1)">搜索</el-button>
            </div>

            <el-table
                :data="allData" stripe
                style="width: 100%"
                :height="this.$tools.mainHeight() - 168"
            >   
                <el-table-column prop="code" label="批号" width="150" show-overflow-tooltip></el-table-column> 
                <el-table-column prop="country" label="国家" width="100">
                    <template slot-scope="rdata">{{ $tools.countryName(rdata.row.country)}}</template>
                </el-table-column>
                <el-table-column prop="title" label="基本信息" width="400" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="经营类型" width="200" show-overflow-tooltip>
                    <template slot-scope="rdata">
                        <el-button type="text" @click="copyType(rdata.row.type)">{{rdata.row.type}}</el-button>
                    </template>

                </el-table-column>
                <el-table-column prop="map" label="地图" width="60">
                    <template slot-scope="rdata">
                        <el-link class="el-icon-location-information" type="primary" v-if="rdata.row.map != null" circle target="_blank" :href="rdata.row.map"></el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="网址" width="200" show-overflow-tooltip>
                    <template slot-scope="rdata">
                        <el-link type="primary" :href="'http://' + rdata.row.id" target="_blank">{{rdata.row.id}}</el-link>
                    </template>
                </el-table-column>
                
                <el-table-column prop="phone" label="电话" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="mail" label="邮箱" width="500" show-overflow-tooltip>
                    <template slot-scope="rdata">
                        <el-tag class="attr-tag" :key="tag" v-for="tag in formatStrint2Arr(rdata.row.mail)">{{tag}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="adress" label="地址" width="300" show-overflow-tooltip></el-table-column>
            </el-table>

            <el-pagination
                layout="total, prev, pager, next"
                :total="step6Data.total"
                :current-page.sync="step6Data.current"
                @current-change="pageAll"
                :page-size="step6Data.size"
            ></el-pagination>
        </el-drawer>
    </div>
</template>

<style lang="scss">
    .gmap-button {
        margin: 0 20px;
    }
</style>

<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";


export default {
    components: { SnUserSearchInput },
    data() { 
        return {
            step1Dialog: false
            ,step2Dialog: false
            ,step3Dialog: false
            ,step4Dialog: false
            ,step4Dialog2: false
            ,step5Dialog: false
            ,step5Dialog2: false
            ,step6Dialog: false
            ,stepaDialog: false
            ,step1Data: {}
            ,step2Data: {}
            ,step3Data: {countryArr:[], valid:""}
            ,step4Data: {countryArr:[], valid:"Y"}
            ,step5Data: {countryArr:[]}
            ,step6Data: {countryArr:[], size: 50}
            ,step5Data2: {}
            ,nameSplit: ","
            ,rules1: {
                country: [
                    {
                        required: true,
                        message: "请选择所属国家",
                        trigger: "blur",
                    },
                ],
            }
            ,fileList1 : []
            ,fileList2 : []
            ,countryprops: {
                value: "id",
                label: "name",
                expandTrigger: "hover",
                emitPath: false,
                multiple: true,
            }
            ,countryprops2: {
                value: "id",
                label: "name",
                expandTrigger: "hover",
                emitPath: false,
            }
            ,validData: []
            ,allData: []
            ,Yndata: [{id: "N", name: "已清洗"}, {id: "Y", name: "已选定"}]
            ,mdata: [{id: "Y", name: "有邮箱"}, {id: "N", name: "无邮箱"}]
            ,tdata: [{id: "Y", name: "已生成"}, {id: "N", name: "未生成"}]
            ,workInfo: {}
            ,users: []
            ,setType: ""
            ,setName: ""
            ,setData:[]
        }
    }
    ,methods:{
        step1() {
            let _this = this;
            _this.step1Data = {};
            _this.step1Dialog = true;
        },

        uploaded1(response, file, fileList) {
            let _file = {
                name: file.name,
                size: file.size,
                address: response.data.address,
                id: response.data.id,
                creator: response.data.creator,
                contentType: response.data.contentType,
                base64: response.data.base64
            };

            this.fileList1.unshift(_file);
        },

        save1() {
            let _this = this;

            _this.$refs["form1"].validate().then(function () {
                let tempList = []
                
                for (var i in _this.fileList1) {
                    tempList.push(_this.fileList1[i].address);
                }

                _this.step1Data.files = tempList

                _this.$http.post(
                    ["customer/gmap/importStep1", _this.step1Data],
                    [
                        function (data) {
                            _this.step1Dialog = false;
                        },
                    ],
                    ".step1-dialog"
                );
            });
        },

        step2() {
            let _this = this;
            
            //_this.step2Dialog = true;
            _this.save2()
        },

        uploaded2(response, file, fileList) {
            let _file = {
                name: file.name,
                size: file.size,
                address: response.data.address,
                id: response.data.id,
                creator: response.data.creator,
                contentType: response.data.contentType,
                base64: response.data.base64
            };

            this.fileList2.unshift(_file);
        },

        save2() {
            let _this = this;

            let tempList = []
                
            for (var i in _this.fileList2) {
                tempList.push(_this.fileList2[i].address);
            }

            _this.step2Data.files = tempList

            _this.$http.post(
                ["customer/gmap/importStep2", _this.step2Data],
                [
                    function (data) {
                        _this.step2Dialog = false;
                    },
                ],
                ".step2-dialog"
            );
        },

        step3() {
            let _this = this;
            _this.pageValid(1, function() {
                _this.step3Dialog = true;
            })            
        },
        pageValid(current, callback) {
            let _this = this;

            if (current) {
                _this.step3Data.current = current;
            }

            _this.step3Data.country = _this.step3Data.countryArr.join(",");

            _this.$http.post(
                ["customer/gmap/listWaitClean", _this.step3Data],
                [
                    function (data) {
                        _this.step3Data.total = data.total;
                        _this.validData = data.records;

                        if (callback) {
                            callback()
                        }
                    },
                ],
                ".step3-dialog"
            );  
        }
        ,pageCreate(current, callback) {
            let _this = this;

            if (current) {
                _this.step4Data.current = current;
            }
            _this.step4Data.valid = "Y";
            _this.step4Data.country = _this.step4Data.countryArr.join(",");

            _this.$http.post(
                ["customer/gmap/listWaitPublic", _this.step4Data],
                [
                    function (data) {
                        _this.step4Data.total = data.total;
                        _this.validData = data.records;

                        if (callback) {
                            callback()
                        }
                    },
                ],
                ".step4-dialog"
            );  
        }
        ,unvalidOne(id) {
            let _this = this;
            _this.step3Data.id = id;
            _this.$http.post(
                ["customer/gmap/unValidOne", _this.step3Data],
                [
                    function (data) {
                        _this.step3Data.total = data.total;
                        _this.validData = data.records;
                    },
                ],
                ".step3-dialog"
            ); 
        }
        ,cleanValidOne(id) {
            let _this = this;

            _this.step3Data.id = id;
            _this.$http.post(
                ["customer/gmap/cleanValidOne", _this.step3Data],
                [
                    function (data) {
                        _this.step3Data.total = data.total;
                        _this.validData = data.records;
                    },
                ],
                ".step3-dialog"
            ); 
        }
        ,validOne(id) {
            let _this = this;

            _this.step3Data.id = id;
            _this.$http.post(
                ["customer/gmap/validOne", _this.step3Data],
                [
                    function (data) {
                        _this.step3Data.total = data.total;
                        _this.validData = data.records;
                    },
                ],
                ".step3-dialog"
            ); 
        }
        ,unvalidList() {
            let _this = this;
            _this.$tConfirm.show("一键清洗会把当前所有搜索结果前200条清洗数据（搜索条件不能为空），是否确认操作？", function (val) {
                if ((_this.step3Data.countryArr == null || _this.step3Data.countryArr.length == 0) && !_this.step3Data.type && !_this.step3Data.code) {
                    _this.$message({
                        message: "搜索条件不能为空",
                        type: "error",
                    });
                } else {
                    _this.$http.post(
                        ["customer/gmap/unValidList", _this.step3Data],
                        [
                            function (data) {
                                _this.step3Data.total = data.total;
                                _this.validData = data.records;
                            },
                        ],
                        ".step3-dialog"
                    );
                }
            })
        }
        ,validList() {
            let _this = this;
            _this.$tConfirm.show("一键选定会把当前所有搜索结果前200条选定数据（搜索条件不能为空），是否确认操作？", function (val) {
                if ((_this.step3Data.countryArr == null || _this.step3Data.countryArr.length == 0) && !_this.step3Data.type && !_this.step3Data.code) {
                    _this.$message({
                        message: "搜索条件不能为空",
                        type: "error",
                    });
                } else {
                    _this.$http.post(
                        ["customer/gmap/validList", _this.step3Data],
                        [
                            function (data) {
                                _this.step3Data.total = data.total;
                                _this.validData = data.records;
                            },
                        ],
                        ".step3-dialog"
                    );
                }
            })
        }
       ,step4() {
            let _this = this;
            
            _this.pageCreate(1, function() {_this.step4Dialog=true})
            
        }
        ,opStep4Dialog2(id) {
            let _this = this;
            _this.step4Dialog2 = true;
            _this.step4Data.id = id
        }
        ,docreate() {
            let _this = this;

           if(!!_this.step4Data.id) {
                _this.createOne(_this.step4Data.id)
           } else {
                _this.createList();
           }
        }

        ,createList() {
            let _this = this;
            _this.$tConfirm.show("一键生成会把当前所有搜索结果前200条数据生成至公海（搜索条件不能为空），是否确认操作？", function (val) {
                if ((_this.step4Data.countryArr == null || _this.step4Data.countryArr.length == 0) && !_this.step4Data.type && !_this.step4Data.code) {
                    _this.$message({
                        message: "搜索条件不能为空",
                        type: "error",
                    });
                } else {
                    _this.$http.post(
                        ["customer/gmap/createList", _this.step4Data],
                        [
                            function (data) {
                                _this.step4Data.total = data.total;
                                _this.validData = data.records;
                                _this.step4Dialog2 = false;
                            },
                        ],
                        ".step4-dialog"
                    );
                }
            })
        }
        ,createOne(id) {
            let _this = this;

            _this.$http.post(
                ["customer/gmap/createOne", {id: _this.step4Data.id, toUser: _this.step4Data.toUser}],
                [
                    function (data) {
                        _this.step4Data.total = data.total;
                        _this.validData = data.records;
                        _this.step4Dialog2 = false;
                    },
                ],
                ".step4-dialog"
            );
        }

        ,step5() {
            let _this = this;
            _this.pageUser(1, function() {_this.step5Dialog=true;})
        }

        ,pageUser(current, callback) {
            let _this = this;

            if (current) {
                _this.step5Data.current = current;
            }

            _this.$http.post(
                ["user/listValid", _this.step5Data],
                [
                    function (data) {
                        _this.step5Data.total = data.total;
                        _this.users = data.records;

                        if (callback) {
                            callback()
                        }
                    },
                ],
                ".step5-dialog"
            );  
        }
        ,setMax(id) {
            let _this = this;
            _this.step5Data2.id = id
            _this.step5Dialog2 = true;
           
        }
        ,saveMax() {
            let _this = this;

            _this.$http.post(
                ["user/setMax", _this.step5Data2],
                [
                    function (data) {
                        _this.step5Data.total = data.total;
                        _this.users = data.records;
                        _this.step5Dialog2 = false;
                    },
                ],
                ".step5-dialog"
            );  
        }
        ,formatStrint2Arr(data) {
            if (!data) {
                return []
            } else if (typeof data == "string") {
                return data.split(this.nameSplit)
            } else {
                return data
            }
        }
        ,getWorkInfo() {
            let _this = this;

            _this.$http.post(
                ["customer/gmap/workInfo"],
                [
                    function (data) {
                        _this.workInfo = data;
                    },
                ],
                ".step4-dialog"
            );
        }
        ,step6() {
            let _this = this;
            _this.pageAll(1, function() {_this.step6Dialog=true;})
        }
        ,pageAll(current, callback) {
            let _this = this;

            if (current) {
                _this.step6Data.current = current;
            }

            _this.step6Data.country = _this.step6Data.countryArr.join(",");

            _this.$http.post(
                ["customer/gmap/allList", _this.step6Data],
                [
                    function (data) {
                        _this.step6Data.total = data.total;
                        _this.allData = data.records;

                        if (callback) {
                            callback()
                        }
                    },
                ],
                ".step6-dialog"
            ); 
        }
        ,stepa(type) {
            let _this = this;
            _this.setType = type;
            _this.listSetData(function() {
                _this.stepaDialog = true;
            })
        }
        ,delSetData(id) {
            let _this = this;

            _this.$tConfirm.show("删除关键词，是否确认操作？", function (val) {
                _this.$http.post(
                    ["customer/gmap/set/del", {id: id, type: _this.setType}],
                    [
                        function (data) {
                            _this.setData = data;
                        },
                    ],
                    ".stepa-dialog"
                );   
            })
        }
        ,addSetData() {
            let _this = this;

            _this.$http.post(
                ["customer/gmap/set/add", {id: _this.setName, type: _this.setType}],
                [
                    function (data, msg) {
                        _this.setName = null;
                        _this.setData = data;
                        msg()
                    },
                ],
                ".stepa-dialog"
            );         
        }
        ,listSetData(callback) {
            let _this = this;

            _this.$http.post(
                ["customer/gmap/set/list", {id: _this.setName, type: _this.setType}],
                [
                    function (data) {
                        _this.setData = data;

                        if (callback) {
                            callback()
                        }
                    },
                ],
                ".stepa-dialog"
            );
        }
        ,autoValid() {
            let _this = this;

            _this.$tConfirm.show("自动清洗当前所有数据，是否确认操作？", function (val) {
                _this.$http.post(  
                    ["customer/gmap/autoValid"],
                    [
                        function (data) {
                            _this.pageValid(1);
                        },
                    ],
                    ".step3-dialog"
                );
            })
        }
        ,copyType(type) {
            let _this = this;

            _this.$copyText(type).then(function (e) {
                _this.$message({message: "拷贝成功" , type: "success"});
            }, function (e) {
                _this.$message({message: "拷贝失败", type: "error"});
            })
        }
    }
    ,mounted() {
        this.getWorkInfo();
    }
}
</script>
<style lang="scss">
    .set-data{
        padding: 10px;
    }
    .set-data-tag {
        margin: 0 10px 5px 0;
    }
</style>